import homeCover from '../../../assets/home-cover.webp';
import { Loading, ProgramsPreview } from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutesPaths } from '../../../routes/types';
import { Card } from '@sandtech-hub-monorepo/ui-kit';
import { ReactComponent as UniversityIcon } from '../../../assets/Icons/patten-university-logo.svg';
import { ReactComponent as MapPinIcon } from '../../../assets/Icons/location-pin-icon.svg';
import React from 'react';
import { useQuery } from '@apollo/client';
import { GetViewerAvailableProgramsDocument } from '@sandtech-hub-monorepo/ehub-client';

export const HomeNotEnrolled = () => {
  const { data } = useQuery(GetViewerAvailableProgramsDocument);

  if (!data) {
    return <Loading />;
  }

  return (
    <div>
      <img
        src={homeCover}
        alt="cover"
        className="w-full max-h-80 object-cover"
      />
      <div className="flex gap-0 md:gap-16 px-6 flex-wrap md:flex-nowrap  max-w-screen-2xl mx-auto">
        <div className="bg-background-secondary p-6 border-background border-4 shadow-background inline-block -translate-y-1/2 -mb-[64px] self-start">
          <UniversityIcon height={108} width={108} />
        </div>
        <div>
          <h1 className="mt-10 text-4xl">
            The School of Entrepreneurship & Technology
          </h1>
          <div className="flex gap-1 mt-4">
            <MapPinIcon color="red" />
            <div>Oakland, California, USA</div>
          </div>
        </div>
      </div>
      <div className="h-full pt-8 px-6 pb-12 sm:pt-16 flex flex-col gap-8 max-w-screen-2xl mx-auto">
        <ProgramsPreview
          title="Available Programs"
          programsPageLink={AppRoutesPaths.Programs}
          learningPageLink={AppRoutesPaths.Learning}
          programPageLink={AppRoutesPaths.Program}
        />
        <Card className="flex gap-8 p-12 flex-wrap bg-banner border-primary">
          <div className="flex-1">
            <h3 className="font-semibold">Course Delivery</h3>
            <div>Online</div>
          </div>
          <div className="border border-r border-primary self-stretch"></div>
          <div className="flex-1">
            <h3 className="font-semibold">Scholarship Availability</h3>
            <div>Yes</div>
          </div>
          <div className="border border-r border-primary self-stretch"></div>
          <div className="flex-1">
            <h3 className="font-semibold">Funding Options</h3>
            <div>Yes</div>
          </div>
          <div className="border border-r border-primary self-stretch"></div>
          <div className="flex-1">
            <h3 className="font-semibold">Estimated Tuition Cost</h3>
            <div>USD $225 per semester</div>
          </div>
        </Card>
        <Card className="p-8">
          <h2 className="text-2xl font-semibold mb-8">Overview</h2>
          <p className="mb-4">
            The School of Entrepreneurship and Technology (SET) recognises
            technology as a powerful catalyst for positive global change. SET is
            a leader in online education and empower students with the skills
            and knowledge needed to address current global challenges with their
            US accredited Bachelor of Science degree programs in Software
            Engineering and Data Science.
          </p>
          <p className="mb-4">
            The School of Entrepreneurship and Technology believes in the
            potential of technology to support a better future for all. Because
            of their commitment to act as a catalyst for positive global change,
            the SET offers sponsored placements into its degree programs. This
            ensures access to high quality education is not dictated by means,
            but driven by talent – no matter where you are from.
          </p>
          <p>
            The School of Entrepreneurship and Technology is a division of
            Elmwood Institute, a DEAC accredited university located in the San
            Francisco Bay Area near tech companies that have changed the world.
          </p>
        </Card>
        <Card className="p-8">
          <h2 className="text-2xl font-semibold mb-8">Sponsored Placements</h2>
          <p className="mb-4">
            The partnership between ALX and the School of Entrepreneurship and
            Technology (SET) offers eligible ALX participants the opportunity to
            qualify for sponsored tuition rates and a reduced length completion
            time in obtaining their Bachelor of Science Degrees.
          </p>
          <p className="mb-4">
            Applicants who successfully complete the ALX Pathway Program and
            meet al admissions requirements established by School of
            Entrepreneurship and Technology (SET) have the opportunity to
            receive a special, sponsored tuition rate of $225 USD per semester,
            a streamlined application process, and credit for prior learning
            that will reduce the time and cost to complete the degree program:
          </p>
          <ul className="list-disc list-inside mb-4">
            <li>Successful completion of ALX Pathway Foundations</li>
            <li>
              Meet all other admissions requirements established by the School
              of Entrepreneurship and Technology (SET)
            </li>
          </ul>
          <p>
            For all other prospective students, the full-time tuition rate of
            $1,333 per semester will be applicable.
          </p>
        </Card>
        <Card className="p-6">
          <h2 className="text-2xl font-semibold mb-8">Accreditations</h2>
          <div className="flex space-x-4">
            <div className="px-6 py-2 bg-background-tertiary rounded-md text-center font-medium border border-border">
              DEAC
            </div>
            <div className="px-6 py-2 bg-background-tertiary rounded-md text-center font-medium border border-border">
              CHEA
            </div>
          </div>
        </Card>
        <Card className="p-6">
          <h2 className="text-2xl font-semibold mb-8">Programmes Available</h2>
          <div className="flex flex-col items-start space-y-4">
            {data.viewer.availablePrograms?.map(({ name, id }) => (
              <div
                key={id}
                className="px-6 py-2 bg-background-tertiary rounded-md font-medium border border-border"
              >
                {name}
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
};
